import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation
import useSmartState from '../../../common/hooks/useSmartState';
import { SmartContext } from '../../../library/Core/SmartContext';
import ManageAlumniService from './ManageAlumniService';
import SearchCriteria from '../../management/alumni-list/SearchCriteria';
import { getFuzzySearchCriteria } from '../../../library/Core/SmartFunctions';

const Layout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const [showSearchCriteria, setShowSearchCriteria] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [userTypeCode, setUserTypeCode] = useState(sessionStorage.getItem('user-type-code'));

    const navigate = useNavigate(); // Initialize useNavigate
    const location = useLocation(); // Initialize useLocation

    // Parse query params to get the 'type'
    const queryParams = new URLSearchParams(location.search);
    const type = parseInt(queryParams.get('type') || '0', 10);
    let templateId = parseInt(queryParams.get('template_id') || '0', 10);
    const isStudentPage = window.location.pathname.includes('student-profiles');

    useEffect(() => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
            return;
        }

        ManageAlumniService.search(state.data.searchCriteria, state.routeInfo.pageName)
            .then((response: any) => {
                setStateValue('alumniList', response.data);
            });
    }, [state.data.searchCriteria]);

     const handleFuzzySearch = (event: any) => {
        event.preventDefault();
        const currentSearchCriteria = state.data.searchCriteria;

        const mergedSearchCriteria = {
            ...currentSearchCriteria,
            ...getFuzzySearchCriteria(fuzzySearchText) 
        };
        setStateValue('searchCriteria',mergedSearchCriteria);
     };

    const handleToggleSearchCriteria = () => {
        setShowSearchCriteria(!showSearchCriteria);
    };

    const handleStudentClick = () => {
        // Construct the base URL
        let url = `/broadcast/student-profiles?template_id=${templateId}&type=${type}`;
        
        // Append event_type=1
        url += `&event_type=1`;
    
        console.log('Redirecting to:', url); // Log the final URL
    
        // Navigate to the final URL
        navigate(url);
    };
    
    const handleAlumniClick = () => {
        // Construct the base URL
        let url = `/broadcast/alumni-profiles?template_id=${templateId}&type=${type}`;
    
        // Append event_type=1
        url += `&event_type=1`;
    
        console.log('Redirecting to:', url); // Log the final URL
    
        // Navigate to the final URL
        navigate(url);
    };
    

    return (
        <div className="main flex-1">
            {/* <section className="updateadditionalinformation"> */}
                {/* <div className="container max-1140 px-lg-0 overflow-hidden"> */}
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="white-block white-block-notopborderradius p-0 h-100">
                                <div className="p-4 p-md-5">
                                    <div className="alumni_statistics">
                                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
                                        <h2 className="font-26 font-600 mb-0 mt-2 mt-sm-3 block-title">
                                                {queryParams.get('event_type') === '1' // Check if event_type is 1
                                                    ? 'Select Users To Invite'
                                                    : type === 5
                                                    ? 'Ask Google Review'
                                                    : type === 6
                                                    ? 'Ask for Referral'
                                                    : userTypeCode === 'SUPER_ADMIN'
                                                    ? 'Student Profile Report'
                                                    : state.formConfig?.title}
                                            </h2>
                                            <div className="dashboard innerpage smart-scroll">
                                                {(type === 5 || type === 6) && (
                                                    <>
                                                        {isStudentPage ? (
                                                            <>
                                                                <button className="btn btn-green me-2">
                                                                    <span>Student</span>
                                                                </button>
                                                                <button
                                                                    className="btn btn-border-gray height-40 overflow-hidden "
                                                                    onClick={handleAlumniClick}>
                                                                    <span>Alumni</span>
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button
                                                                    className="btn btn-border-gray height-40 overflow-hidden"
                                                                    onClick={handleStudentClick}>
                                                                    <span>Student</span>
                                                                </button>

                                                                <button className="btn btn-green me-2 ms-2 height-40">
                                                                    <span>Alumni </span>
                                                                </button>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                                            <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                                                <button className="btn-grpfiter me-3" type="button" onClick={handleToggleSearchCriteria}>
                                                    <i className="icon-filter font-13 me-2"></i>
                                                    Filters
                                                </button>
                                                <div className="search alumniSearch m-0 open position-static flex-1">
                                                    <form className="form-inline d-flex flex-wrap justify-content-between d-block" onSubmit={handleFuzzySearch}>
                                                        <input
                                                            value={fuzzySearchText}
                                                            placeholder={state.data.reportConfig.fuzzySearchPlaceholder}
                                                            aria-label="Search"
                                                            className="form-control flex-1 font-13 font-500 text-truncate"
                                                             onChange={(event) => setFuzzySearchText(event?.target.value)}
                                                        />
                                                     <button className="btn btn-search icon icon-search"></button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        {showSearchCriteria && <SearchCriteria />}
                                        {props.children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            // </section>
        // </div>
    );
};

export default Layout;
